/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'

const Footer: FC = () => {
  return (
    <footer
      className='w-full bg-white border-t py-4 flex justify-center items-center'
      id='kt_footer'
    >
      <div className='text-center text-sm text-gray-600'>
        <span className='mr-1'>&copy; {new Date().getFullYear()}</span>
        <a
          href='https://velocitymgr.com/'
          className='text-gray-800 hover:text-primary font-semibold'
        >
          velocity manager
        </a>
      </div>
    </footer>
  )
}

export {Footer}
